import { useTranslation } from "react-i18next";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getFiltersSurveyImport } from "../api/getFiltersSurveyImport";

type QueryFnType = typeof getFiltersSurveyImport;
type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useFiltersSurveyImport = (config?: UseFiltersOptions) => {
    const { t } = useTranslation(["survey"]);
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["filterSurveyLoads", i18n.language],
        queryFn: async () => {
            const filters = await getFiltersSurveyImport(t);

            // translate here
            return filters;
        }
    });
};